<button
  class="btn btn-link"
  [disabled]="locked"
  cpGTagEvent
  [params]="{ event_label: 'payroll_open_holds_override_settings' }"
  (click)="openPayrollConfig(content)">
  Set Temporary Holds or Overrides
</button>
<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Set Temporary Holds or Overrides</h4>
    <button
      cpGTagEvent
      [params]="{ event_label: 'people_edit_direct_deposit_account_modal_dismiss' }"
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <h6 style="border-bottom: 2px solid #6aaa37" class="mb-3 pb-2 width-fit-content">
      Override / Holds
    </h6>
    <div class="overrides-wrapper">
      <div *ngIf="manualChecks && manualChecks.length" style="color: #dc8835">
        <small>
          <em>
            <strong>Holds will not affect Manual Checks included in this payroll</strong>
          </em>
        </small>
      </div>
      <!-- PAY FREQUENCY OVERRIDE-->
      <div class="py-2 border-bottom">
        <button
          (click)="expandFrequencyOverride = !expandFrequencyOverride"
          class="collapse-button btn btn-outline-link px-2 py-1 me-2">
          <i class="fas fa-xs" [ngClass]="expandFrequencyOverride ? 'fa-minus' : 'fa-plus'"></i>
        </button>
        &nbsp;
        <input
          [(ngModel)]="overridePayFrequency"
          (ngModelChange)="togglePayFrequencyOverride()"
          class="small"
          type="checkbox"
          id="override-pay-freq"
          value="false" />
        <label for="override-pay-freq"
          ><span></span>&nbsp; <strong>Override Pay Frequency</strong>&nbsp;
          <small>(to set an override pay frequency for everyone paid in this payroll)</small>
        </label>
      </div>
      <div
        class="override-row"
        [ngbCollapse]="
          !expandFrequencyOverride &&
          config.PayrollFrequencyOverride == null &&
          !overridePayFrequency
        ">
        <small>
          <strong>
            The selected pay frequency will be set as the default pay frequency for all pays
            included in this payroll
          </strong>
        </small>
      </div>
      <div
        class="override-row"
        [ngbCollapse]="
          !expandFrequencyOverride &&
          config.PayrollFrequencyOverride == null &&
          !overridePayFrequency
        ">
        <label>Pay Frequency</label>&nbsp;
        <select
          class="form-control d-inline width-fit-content"
          [(ngModel)]="config.PayrollFrequencyOverride"
          [disabled]="!overridePayFrequency">
          <option
            *ngFor="let frequency of payrollFrequencies | enumToKeyValue"
            [value]="frequency.value">
            {{ frequency.key | camelToTitle }}
          </option>
        </select>
      </div>
      <!-- EARNING OVERRIDES -->
      <div class="py-2 border-bottom">
        <button
          [disabled]="anyEarningOverridesSelected()"
          (click)="expandEarningOverrides = !expandEarningOverrides"
          class="collapse-button btn btn-outline-link px-2 py-1 me-2">
          <i
            class="fas fa-xs"
            [ngClass]="
              expandEarningOverrides || anyEarningOverridesSelected() ? 'fa-minus' : 'fa-plus'
            "></i>
        </button>
        &nbsp;
        <input
          [attr.disabled]="timeclockFile ? 'disabled' : null"
          (change)="toggleSelectAllEarnings($event)"
          [checked]="allEarningOverridesSelected()"
          class="small"
          type="checkbox"
          id="select-all-earnings"
          value="false" />
        <label for="select-all-earnings"
          ><span></span>&nbsp; <strong>Hold Earnings</strong>&nbsp;
          <small>(to set the normal earning amounts to zero for this payroll)</small>
        </label>
      </div>
      <div
        *ngIf="timeclockFile"
        class="override-row"
        [ngbCollapse]="!expandEarningOverrides && !anyEarningOverridesSelected()">
        <small class="text-danger"
          >Earnings holds not allowed. Time Clock earnings included in this payroll</small
        >
      </div>
      <div
        *ngFor="let earning of configSetupData.Earnings; let i = index"
        [ngbCollapse]="!expandEarningOverrides && !anyEarningOverridesSelected()">
        <div class="override-row">
          <input
            [(ngModel)]="config.HoldEarnings[i]"
            [attr.disabled]="timeclockFile ? 'disabled' : null"
            (ngModelChange)="onOverrideChange(config.HoldEarnings, i, earning.Id)"
            class="small"
            type="checkbox"
            id="earning-{{ earning.Id }}"
            value="true" />
          <label class="d-flex align-items-center" for="earning-{{ earning.Id }}"
            ><span></span>&nbsp;{{ earning.Name }}</label
          >
        </div>
      </div>
      <!-- DEDUCTION OVERRIDES -->
      <ng-container *ngIf="configSetupData.Deductions.length">
        <div class="py-2 border-bottom">
          <button
            [disabled]="anyDeductionOverridesSelected()"
            (click)="expandDeductionOverrides = !expandDeductionOverrides"
            class="collapse-button btn btn-outline-link px-2 py-1 me-2">
            <i
              class="fas fa-xs"
              [ngClass]="
                expandDeductionOverrides || anyDeductionOverridesSelected() ? 'fa-minus' : 'fa-plus'
              "></i>
          </button>
          &nbsp;
          <input
            (change)="toggleSelectAllDeductions($event)"
            [checked]="allDeductionOverridesSelected()"
            class="small"
            type="checkbox"
            id="select-all-deductions"
            value="false" />
          <label for="select-all-deductions"
            ><span></span>&nbsp; <strong>Hold Deductions</strong>&nbsp;
            <small>(to set the normal deduction amounts to zero for this payroll)</small>
          </label>
        </div>
        <div
          *ngFor="let deduction of configSetupData.Deductions; let i = index"
          [ngbCollapse]="!expandDeductionOverrides && !anyDeductionOverridesSelected()">
          <div class="override-row">
            <input
              [(ngModel)]="config.HoldDeductions[i]"
              (ngModelChange)="onOverrideChange(config.HoldDeductions, i, deduction.Id)"
              class="small"
              type="checkbox"
              id="deduction-{{ deduction.Id }}"
              value="true" />
            <label class="d-flex align-items-center" for="deduction-{{ deduction.Id }}"
              ><span></span>&nbsp;{{ deduction.Name }}</label
            >
          </div>
        </div>
      </ng-container>
      <!-- DIRECT DEPOSIT OVERRIDE -->
      <div *ngIf="locationConfig.AllowDirectDeposit" class="py-2 border-bottom">
        <button class="collapse-button btn btn-outline-link px-2 py-1 me-2 invisible">
          &nbsp;
        </button>
        &nbsp;
        <input
          [(ngModel)]="config.HoldDirectDeposit"
          class="small"
          type="checkbox"
          id="hold-dd"
          value="true" />
        <label for="hold-dd"
          ><span></span>&nbsp; <strong>Hold Direct Deposit </strong>&nbsp;
          <small>(to produce check payments to everyone paid in this payroll)</small>
        </label>
      </div>
      <!-- TAX OVERRIDES -->
      <ng-container *ngIf="incomeTaxes.length">
        <div class="py-2 border-bottom">
          <button
            [disabled]="anyTaxOverridesSelected()"
            (click)="expandTaxOverrides = !expandTaxOverrides"
            class="collapse-button btn btn-outline-link px-2 py-1 me-2">
            <i
              class="fas fa-xs"
              [ngClass]="
                expandTaxOverrides || anyTaxOverridesSelected() ? 'fa-minus' : 'fa-plus'
              "></i>
          </button>
          &nbsp;
          <input
            (change)="toggleSelectAllTaxes($event)"
            class="small"
            type="checkbox"
            id="select-all-taxes"
            [checked]="allTaxOverridesSelected()"
            value="false" />
          <label for="select-all-taxes"
            ><span></span>&nbsp;
            <strong>Hold Taxes</strong>
          </label>
        </div>
        <div
          class="override-row row"
          [ngbCollapse]="!expandTaxOverrides && !anyTaxOverridesSelected()">
          <small
            >Select the checkbox to hold/override the tax. Enter and override amount to set a
            temporary withholding amount for this payroll.</small
          >
        </div>
        <div
          class="override-row row"
          [ngbCollapse]="!expandTaxOverrides && !anyTaxOverridesSelected()">
          <div class="col-4">
            <small><strong>Hold/Override</strong></small>
          </div>
          <div class="col-4">
            <small><strong>Override Percentage</strong></small>
          </div>
        </div>
        <div
          *ngFor="let tax of incomeTaxes; let i = index"
          [ngbCollapse]="!expandTaxOverrides && !anyTaxOverridesSelected()">
          <div class="override-row row" *ngIf="tax.TaxType != 'Local'">
            <div class="col-4">
              <input
                [(ngModel)]="config.HoldTaxes[i].Id"
                (ngModelChange)="onTaxOverrideChange(i, tax)"
                class="small"
                type="checkbox"
                id="tax-{{ tax.TaxCode }}"
                [value]="tax.TaxCode" />
              <label class="d-flex align-items-center" for="tax-{{ tax.TaxCode }}"
                ><span></span>&nbsp;{{ tax.DisplayName }}</label
              >
            </div>
            <div class="col-2">
              <input
                appNumberInput
                [attr.disabled]="!config.HoldTaxes[i].Id ? 'disabled' : null"
                [(ngModel)]="config.HoldTaxes[i].OverridePercentage"
                class="small w-100"
                type="number"
                placeholder="0.00"
                min="0"
                (ngModelChange)="
                  config.HoldTaxes[i].OverridePercentage =
                    config.HoldTaxes[i].OverridePercentage > 100
                      ? 100
                      : config.HoldTaxes[i].OverridePercentage
                " />
            </div>
          </div>
          <!-- local tax checkbox for this state -->
          <div *ngIf="tax.TaxType == 'Local'" class="override-row row">
            <div class="col-4">
              <input
                [(ngModel)]="config.HoldTaxes[i].Id"
                [disabled]="disableLocalTax(tax.StateAbbreviation)"
                (ngModelChange)="onTaxOverrideChange(i, tax, true)"
                class="small"
                type="checkbox"
                id="LocalTax-{{ tax.StateAbbreviation }}"
                value="LocalTax-{{ tax.StateAbbreviation }}" />
              <label class="d-flex align-items-center" for="LocalTax-{{ tax.StateAbbreviation }}"
                ><span></span>&nbsp;{{ tax.StateAbbreviation }}
                Local Taxes
              </label>
            </div>
            <div class="col-2">&nbsp;</div>
          </div>
        </div>
      </ng-container>
      <!-- TTIME OFF OVERRIDES -->
      <ng-container *ngIf="ptoConfigs?.length > 0">
        <div class="py-2 border-bottom">
          <button
            [disabled]="anyTimeOffOverridesSelected()"
            (click)="expandTimeOffOverrides = !expandTimeOffOverrides"
            class="collapse-button btn btn-outline-link px-2 py-1 me-2">
            <i
              class="fas fa-xs"
              [ngClass]="
                expandTimeOffOverrides || anyTimeOffOverridesSelected() ? 'fa-minus' : 'fa-plus'
              "></i>
          </button>
          &nbsp;
          <input
            (change)="toggleSelectAllTimeOff($event)"
            [checked]="allTimeOffOverridesSelected()"
            class="small"
            type="checkbox"
            id="select-all-time-off"
            value="false" />
          <label for="select-all-time-off"
            ><span></span>&nbsp; <strong>Hold Time Off</strong>&nbsp;
            <small>(to set the accrual rate to zero for this payroll)</small>
          </label>
        </div>
        <div
          *ngFor="let timeoff of ptoConfigs; let i = index"
          [ngbCollapse]="!expandTimeOffOverrides && !anyTimeOffOverridesSelected()">
          <div class="override-row">
            <input
              [(ngModel)]="config.HoldTimeOff[i]"
              (ngModelChange)="onOverrideChange(config.HoldTimeOff, i, timeoff.Id)"
              class="small"
              type="checkbox"
              id="time-off-{{ timeoff.Id }}"
              value="true" />
            <label class="d-flex align-items-center" for="time-off-{{ timeoff.Id }}"
              ><span></span>&nbsp;{{ timeoff.Name }}</label
            >
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="modal-footer">
    <button
      (click)="modal.dismiss()"
      type="button"
      class="btn btn-secondary"
      cpGTagEvent
      [params]="{ event_label: 'payroll_cancel_holds_override_settings' }">
      Cancel
    </button>
    <button
      (click)="modal.close()"
      type="button"
      class="btn btn-primary"
      cpGTagEvent
      [params]="{ event_label: 'payroll_save_holds_override_settings', data: config }">
      Save
    </button>
  </div>
</ng-template>
